import dayjs from 'dayjs';

/** Newest added entry first (created_at → timestamp → id). */
export function sortDiaryEntriesNewestFirst<T extends Record<string, any>>(entries: T[]): T[] {
  return [...entries].sort((a, b) => {
    const diff = diaryEntryAddedAt(b) - diaryEntryAddedAt(a);
    if (diff !== 0) return diff;
    return (Number(b?.id) || 0) - (Number(a?.id) || 0);
  });
}

function diaryEntryAddedAt(entry: Record<string, any> | null | undefined): number {
  if (!entry) return 0;
  const raw =
    entry.created_at ||
    entry.timestamp ||
    entry.movement_time ||
    entry.entry_date ||
    entry.visit_date ||
    entry.test_date;
  const ms = raw ? new Date(raw).getTime() : NaN;
  if (Number.isFinite(ms)) return ms;
  return Number(entry.id) || 0;
}

/** Date+time for diary tables. */
export function formatDiaryDateTime(entry: Record<string, any> | null | undefined): string {
  if (!entry) return '-';
  const raw =
    entry.timestamp ||
    entry.movement_time ||
    entry.created_at ||
    entry.entry_date ||
    entry.visit_date ||
    entry.test_date;
  if (!raw) return '-';
  const d = dayjs(raw);
  return d.isValid() ? d.format('DD.MM.YYYY HH:mm') : '-';
}
